import { DataExportStatus } from "@sp-crm/core";

export const dataExportPollIntervalMs = 3000;

const inProgressStatuses = [DataExportStatus.Pending, DataExportStatus.Processing];

export const dataExportRefetchInterval = (
    statuses: DataExportStatus[],
): number | false =>
    statuses.some(status => inProgressStatuses.includes(status))
        ? dataExportPollIntervalMs
        : false;

export const dataExportMaxPollAgeMs = 30 * 60 * 1000;

interface DataExportProgress {
    status: DataExportStatus;
    createdAt: string;
}

const startedRecently = (dataExport: DataExportProgress, now: Date): boolean =>
    now.getTime() - Date.parse(dataExport.createdAt) <= dataExportMaxPollAgeMs;

export const recentDataExportRefetchInterval = (
    dataExports: DataExportProgress[],
    now: Date,
): number | false =>
    dataExportRefetchInterval(
        dataExports
            .filter(dataExport => startedRecently(dataExport, now))
            .map(dataExport => dataExport.status),
    );

export const isRecentDataExportInProgress = (
    dataExport: DataExportProgress,
    now: Date,
): boolean => recentDataExportRefetchInterval([dataExport], now) !== false;

export const downloadDataExportFile = (fileId: string): void => {
    window.location.href = `/api/files/download/${fileId}`;
};
